import React from "react";
import "./Header.css";
import img from "../../assets/1.jpg";
import { Typewriter } from "react-simple-typewriter";

import { BsFacebook, BsLinkedin, BsGithub, BsTwitter } from "react-icons/bs";

const Header = () => {
  return (
    <header className="Header" id="home">
      <div className="header-container">
        <div className="Header-text">
          <h1>hi my name is emmanuel</h1>
          <p>
            <Typewriter
              loop
              cursor
              cursorStyle="|"
              typeSpeed={70}
              deleteSpeed={20}
              delaySpeed={1500}
              words={[
                "i am a data scientist",
                "and also a fullstack web developer",
              ]}
            />
          </p>{" "}
          <div className="social-links">
            <a
              href="https://web.facebook.com/boniface.emmanuel.5249/"
              target="_blank"
            >
              <BsFacebook
                size={33}
                className="social-icons"
                color={"#4c00ff"}
              />
            </a>
            <a
              href="https://www.linkedin.com/in/emmanuel-boniface300/"
              target="_blank"
            >
              <BsLinkedin
                size={33}
                className="facebook social-icons"
                color={"#0e76a8"}
                target="_blank"
              />
            </a>
            <a href="https://github.com/Gemack" target="_blank">
              <BsGithub
                size={33}
                className="facebook social-icons"
                color={"#000"}
                target="_blank"
              />
            </a>
            <a href="https://twitter.com/Emack300" target="_blank">
              <BsTwitter
                size={33}
                className="facebook social-icons"
                color={"skyblue"}
                target="_blank"
              />
            </a>
          </div>
        </div>
        <div className="Header-img">
          <img src={img} alt="myImage" />
        </div>
      </div>
    </header>
  );
};

export default Header;
